// src/pages/profile-settings/patient/SettingsHome.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import TopBar from "@/sot/primitives/TopBar.jsx";
import SettingsScreenShell from "@/sot/layouts/SettingsScreenShell.jsx";
import SettingsHomeCommon from "@/features/settings/SettingsHomeCommon.jsx";
import SettingsWelcome from "./SettingsWelcome.jsx";
import useSettingsWelcomeGate from "@/hooks/useSettingsWelcomeGate.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";
import FolaOnboardingCard from "@/pages/profile-settings/FolaOnboardingCard.jsx";

export default function PatientSettingsHome() {
  const nav = useNavigate();
  const welcome = useSettingsWelcomeGate("patient");
  const { t } = useLanguage();

  return (
    <SettingsScreenShell>
      <TopBar title={t("settings.home.title", "Settings")} onBack={() => nav(-1)} />

      <SettingsWelcome
        open={welcome.open}
        name={welcome.name}
        salutation={welcome.salutation}
        lastName={welcome.lastName}
        onClose={welcome.onClose}
      />

      <div className="mt-4">
        <FolaOnboardingCard role="patient" />
      </div>

      <div className="mt-4">
        <SettingsHomeCommon role="patient" />
      </div>
    </SettingsScreenShell>
  );
}
